<template>
    <div>
      <div class="w-100 h-100">
        <Nav :rolname="rolname" />
      </div>
      <div class="content">
        <Home v-if="page=='home'" @mtdChangePage="mtdChangePage" @mtdBackCampus = "mtdBackCampus"/>
        <Options v-if="page == 'options'" @mtdChangePage="mtdChangePage"></Options>
        <Reports v-if="page == 'reports'" @mtdChangePage="mtdChangePage"></Reports>
        <PermisionsVue v-if="page == 'permiso_caja'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <AnulacionesVue v-if="page == 'permiso_anulacion'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <PermisoOrdenServicioVue v-if="page == 'permiso_os'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <RepCajaVue v-if="page == 'reporte_caja'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <RepIngresoEgreso v-if="page == 'inreso_egreso'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <ConsultarDocumento v-if="page == 'consultas'" :prefix="prefix" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <CajaFuerteVue v-if="page == 'per_caja_fuerte'" @returnHome="returnHome" @mtdChangePage="mtdChangePage" />
        <NoteVue v-if="page == 'note'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <WorkOrder v-if="page == 'work'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
        <Cierre v-if="page == 'cierre_caja'" @returnHome="returnHome" @mtdChangePage="mtdChangePage" />
        <Cxc v-if="page == 'cxc'" @returnHome="returnHome" @mtdChangePage="mtdChangePage"/>
      </div>
      <div class="footer">
        <Footer @mtdChangePage="mtdChangePage" :pageView="page" />
      </div>
    </div>
</template>
  
  <script>
  import { mapActions } from 'vuex'
  import Home from "@/components/Gerencia/Home.vue";
  import Nav from "../../components/Gerencia/Nav.vue";
  import Footer from "../../components/Gerencia/Footer.vue";
  import PermisionsVue from "@/components/Gerencia/pages/PermisionsView.vue";
  import AnulacionesVue from "@/components/Gerencia/pages/AnulacionesView.vue";
  import NoteVue from "@/components/Gerencia/pages/LogisticaView.vue";
  import PermisoOrdenServicioVue from '@/components/Gerencia/pages/PermisoOrdenServicioView.vue';
  import RepCajaVue from "@/components/Gerencia/pages/ReporteCajaView.vue";
  import RepIngresoEgreso from "@/components/JefeAdmision/pages/EgresoIngreso.vue";
  import ConsultarDocumento from "@/components/Gerencia/pages/ConsultarDocumento.vue";
  import Options from "@/components/Gerencia/Footer/Permissions.vue";
  import Reports from "@/components/Gerencia/Footer/Report.vue";
  import CajaFuerteVue from '../../components/Gerencia/pages/PermisoCierreCaja.vue';
  import WorkOrder from '../../components/Gerencia/pages/WorkOrder.vue';
  import Cierre from "../../components/Gerencia/pages/Cierre.vue";
  import Cxc from "@/components/Gerencia/pages/CxcGerencia.vue";
  export default {
    name: "GerenciaView",
    components: {
      Nav,
      Home,
      Footer,
      Options,
      Reports,
      PermisionsVue,
      AnulacionesVue,
      RepCajaVue,
      RepIngresoEgreso,
      PermisoOrdenServicioVue,
      ConsultarDocumento,
      NoteVue,
      CajaFuerteVue,
      WorkOrder,
      Cierre,
      Cxc,
    },
  
    data() {
      return {
        prefix: 'gerencia',
        page:'home',
        rol_name: null,
        stateRolAdmin: false,
      };
    },
    props: {
      rolname: String,
      dataRoles: Array,
      campu: Number,
    },
    created () {
      this.rol_name = this.rolname;
      this.mtdGetRolAdmin();
    },
    methods: {
      ...mapActions(['get', 'post']),
      mtdChangePage: function(page){
        this.page = page;
      },
      returnHome: function () {
        this.page = "home";
      },
      mtdGetRolAdmin:function(){
        this.dataRoles.forEach(element => {
          if(element.role_id==1){
            this.stateRolAdmin = true;
          }
        });
      },
      mtdBackCampus:function(){
        this.$emit('mtdBackCampus');
      }
    }
  };
</script>
